import Service from './server/index';
import request from './request/request';

export default class {
  constructor(option) {
    const service = new Service(option);
    // service.initRequest = service.initRequest;
    service.request = request(service.initRequest);
    return service;
  }
}
